import { useState } from 'react';
import { Plus, Trash2, Tags, Store, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';
import { useHesapAuth } from '../../store/hesapStore';
import { useVitrinCategories, parseFieldSpec, fieldSpecOf } from '../../lib/vitrinCategories';
import { StokTab, useStokRecords } from './HesapTeknikServisPage';

const CategoryManager = ({ custom, save }) => {
  const [name, setName] = useState('');
  const [spec, setSpec] = useState('');
  const add = async () => {
    if (!name.trim()) return;
    const key = `ozel_${Date.now().toString(36)}`;
    try { await save([...custom, { key, label: name.trim(), fields: parseFieldSpec(spec) }]); setName(''); setSpec(''); toast.success('Kategori eklendi'); }
    catch (e) { toast.error(e.message); }
  };
  const remove = async (key) => {
    if (!window.confirm('Kategori silinsin mi? (Bu kategorideki ürünler silinmez)')) return;
    try { await save(custom.filter(c => c.key !== key)); } catch (e) { toast.error(e.message); }
  };
  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-5 space-y-3" data-testid="vitrin-category-manager">
      <h3 className="font-semibold flex items-center gap-2"><Tags className="h-4 w-4 text-emerald-600" /> Kendi Kategorilerim</h3>
      <p className="text-xs text-slate-500">Hazır kategoriler: Telefon, Tablet, Bilgisayar, Televizyon, Beyaz Eşya, Mobilya, Küçük Ev Aleti, Diğer. Kendi kategorinizi ve sorularını ekleyebilirsiniz.</p>
      {custom.map(c => (
        <div key={c.key} className="flex items-start justify-between gap-3 border rounded-xl p-3">
          <div><p className="font-medium text-sm">{c.label}</p><p className="text-xs text-slate-500">{fieldSpecOf(c.fields) || 'Soru yok'}</p></div>
          <button onClick={() => remove(c.key)} className="text-red-500 p-1" data-testid={`vitrin-cat-del-${c.key}`}><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="grid sm:grid-cols-[180px_1fr_auto] gap-2">
        <input value={name} onChange={e => setName(e.target.value)} placeholder="Kategori adı (ör. Bisiklet)" className="border rounded-xl px-3 py-2 text-sm" data-testid="vitrin-cat-name" />
        <input value={spec} onChange={e => setSpec(e.target.value)} placeholder="Sorular: Jant:sayı, Vites:Var|Yok, Renk" className="border rounded-xl px-3 py-2 text-sm" data-testid="vitrin-cat-spec" />
        <button onClick={add} className="inline-flex items-center justify-center gap-1 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold rounded-xl px-4 py-2" data-testid="vitrin-cat-add"><Plus className="h-4 w-4" /> Ekle</button>
      </div>
      <p className="text-[11px] text-slate-400">Yazım: virgülle ayırın. "Ad:sayı" sayı alanı, "Ad:A|B|C" seçenek listesi, sadece "Ad" yazı alanı olur.</p>
    </div>
  );
};

export default function HesapVitrinPage() {
  const { token, user } = useHesapAuth();
  const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  const { records, loading, refresh } = useStokRecords(headers);
  const cats = useVitrinCategories(token);
  const vitrinUrl = `${window.location.origin}/vitrin/${user?.tenant_id || user?.id}`;

  return (
    <div className="space-y-5" data-testid="hesap-vitrin-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 text-white shadow-md"><Store className="h-6 w-6" /></div>
          <div><h1 className="text-2xl font-bold">Ürün Vitrini</h1><p className="text-sm text-slate-500">Sıfır ve 2. el ürünlerinizi ekleyin, linkle müşterinize gönderin</p></div>
        </div>
        <a href={vitrinUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-medium border rounded-full px-4 py-2 hover:bg-slate-50" data-testid="vitrin-open-store">
          <ExternalLink className="h-4 w-4" /> Vitrin Sayfamı Aç
        </a>
      </div>
      <StokTab records={records} loading={loading} token={token} headers={headers} onRefresh={refresh} customCategories={cats.custom} />
      <CategoryManager custom={cats.custom} save={cats.save} />
    </div>
  );
}
